import { render, staticRenderFns } from "./year-month-input.vue?vue&type=template&id=2763929c&scoped=true"
import script from "./year-month-input.vue?vue&type=script&lang=ts&setup=true"
export * from "./year-month-input.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./year-month-input.vue?vue&type=style&index=0&id=2763929c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2763929c",
  null
  
)

export default component.exports